<template>
  <v-container class="my-5">
    <v-card class="elevation-3">
      <v-toolbar dark flat color="blue darken-3">
        <v-icon left>mdi-account-multiple</v-icon>
        <v-toolbar-title>Socios - Casa Club</v-toolbar-title>
      </v-toolbar>

      <v-card-text class="pt-5">
        <v-row class="mb-4">
          <v-col cols="12" sm="4">
            <v-text-field
              v-model="searchName"
              prepend-inner-icon="mdi-magnify"
              label="Buscar por nombre"
              outlined
              dense
              hide-details
              clearable
              color="blue darken-2"
              @keyup.enter="searchSociosClick"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              v-model="searchSocio"
              prepend-inner-icon="mdi-magnify"
              label="Buscar por socio"
              outlined
              dense
              hide-details
              clearable
              color="blue darken-2"
              @keyup.enter="searchSociosClick"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="2">
            <v-select
              v-model="filterStatus"
              :items="[
                { text: 'Todos', value: null },
                { text: 'Activo', value: 'Activo' },
                { text: 'Suspendido', value: 'Suspendido' },
                { text: 'Baja', value: 'Baja' },
                { text: 'Inactivo', value: 'Inactivo' }
              ]"
              item-text="text"
              item-value="value"
              label="Estado"
              outlined
              dense
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" sm="3">
            <v-select
              v-model="filterMoroso"
              :items="[
                { text: 'Todos', value: null },
                { text: 'Moroso', value: true },
                { text: 'Al Día', value: false }
              ]"
              item-text="text"
              item-value="value"
              label="Estado de Pago"
              outlined
              dense
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" sm="2">
            <v-btn
              color="blue darken-2"
              dark
              block
              @click="searchSociosClick"
              :loading="loadingSocios"
            >
              <v-icon left>mdi-magnify</v-icon>
              Buscar
            </v-btn>
          </v-col>
        </v-row>

        <v-data-table
          :headers="headersSocios"
          :items="socios"
          :loading="loadingSocios"
          hide-default-footer
          loading-text="Cargando socios..."
          no-data-text="No hay socios registrados"
          no-results-text="No se encontraron socios"
        >
          <template v-slot:item.status="{ item }">
            <v-chip small :color="statusColor(displayStatus(item))" text-color="white" class="font-weight-bold">
              {{ displayStatus(item) }}
            </v-chip>
          </template>
          <template v-slot:item.is_moroso="{ item }">
            <v-chip
              small
              :color="item.is_moroso ? 'red darken-1' : 'green'"
              text-color="white"
              class="font-weight-bold"
            >
              {{ item.is_moroso ? 'Moroso' : 'Al Día' }}
            </v-chip>
          </template>
        </v-data-table>

        <div class="d-flex align-center justify-space-between mt-3" v-if="sociosTotal > 0">
          <span class="text-caption grey--text">Total: {{ sociosTotal }} socios</span>
          <div>
            <v-btn icon small :disabled="sociosPage <= 1 || loadingSocios" @click="prevSociosPage">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <span class="mx-2 text-caption">Página {{ sociosPage }} de {{ sociosTotalPages }}</span>
            <v-btn icon small :disabled="sociosPage >= sociosTotalPages || loadingSocios" @click="nextSociosPage">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="2500">
      <v-icon left>{{ snackbarIcon }}</v-icon>
      {{ snackbarText }}
    </v-snackbar>
  </v-container>
</template>

<script>
const API_KEY = 'NK3ZlH8Jzhk4Vgwdti3cQ_VyG99v323seGTwozqtCgw'
const CCSLP_USERS_API = 'https://club-services.intrare.app/ccslp/users/'

export default {
  name: 'ClubHouseSocios',
  data () {
    return {
      searchName: '',
      searchSocio: '',
      filterStatus: null,
      filterMoroso: null,
      loadingSocios: false,
      socios: [],
      sociosPage: 1,
      sociosLimit: 100,
      sociosTotal: 0,
      snackbar: false,
      snackbarText: '',
      snackbarColor: 'success',
      snackbarIcon: 'mdi-check-circle',
      headersSocios: [
        { text: 'Nombre', value: 'name' },
        { text: 'Socio', value: 'socio' },
        { text: 'ID Dependiente', value: 'id_dependiente' },
        { text: 'Status', value: 'status' },
        { text: 'Moroso', value: 'is_moroso' }
      ]
    }
  },

  computed: {
    sociosTotalPages () {
      return this.sociosTotal > 0 ? Math.ceil(this.sociosTotal / this.sociosLimit) : 1
    }
  },

  mounted () {
    this.fetchSocios()
  },

  methods: {
    displayStatus (item) {
      if (item.is_moroso) return 'Moroso'
      if (!item.status) return 'N/A'
      return item.status
    },

    statusColor (status) {
      switch (status) {
        case 'Activo':
          return 'green'
        case 'Suspendido':
          return 'red darken-1'
        case 'Baja':
          return 'grey darken-1'
        case 'Inactivo':
          return 'orange darken-1'
        case 'Moroso':
          return 'red darken-1'
        case 'N/A':
          return 'grey'
        default:
          return 'grey'
      }
    },

    searchSociosClick () {
      this.sociosPage = 1
      this.fetchSocios()
    },

    prevSociosPage () {
      if (this.sociosPage > 1) {
        this.sociosPage--
        this.fetchSocios()
      }
    },

    nextSociosPage () {
      if (this.sociosPage < this.sociosTotalPages) {
        this.sociosPage++
        this.fetchSocios()
      }
    },

    fetchSocios () {
      this.loadingSocios = true
      const params = {
        api_key: API_KEY,
        limit: this.sociosLimit,
        offset: (this.sociosPage - 1) * this.sociosLimit
      }
      if (this.searchName) params.name = this.searchName
      if (this.searchSocio) params.socio = this.searchSocio
      if (this.filterStatus) params.status = this.filterStatus
      if (this.filterMoroso !== null) params.is_moroso = this.filterMoroso

      const config = {
        method: 'get',
        url: CCSLP_USERS_API,
        params
      }

      this.$axios(config)
        .then(response => {
          this.socios = (response.data && response.data.users) || []
          this.sociosTotal = (response.data && response.data.total) || 0
          this.showMessage('Socios cargados correctamente', 'success', 'mdi-check-circle')
        })
        .catch(error => {
          console.error('Error fetching CCSLP users:', error)
          this.showMessage('Error al cargar socios', 'error', 'mdi-alert-circle')
        })
        .finally(() => {
          this.loadingSocios = false
        })
    },

    showMessage (text, color, icon) {
      this.snackbarText = text
      this.snackbarColor = color
      this.snackbarIcon = icon
      this.snackbar = true
    }
  }
}
</script>

<style scoped>
</style>
